module.exports = "<p style=\"margin-top:100px\">\n  page-not-found works!\n</p>\n"